export default __webpack_public_path__ + "127f44b8a6bc42f66dcc41bd24428c6e.png";